import styled from "styled-components";

export const StyledLayout = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 100px;
    width: 100vw;
`;